export default "__VITE_ASSET__CnhnQ7cc__"